'use strict';

const base = require('base/product/base');
const validateVarient = require('./validateVarient');

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        const $this = $(this);
        childProducts.push({
            pid: $this.find('.product-id').text(),
            quantity: parseInt($this.find('label.quantity').data('quantity'), 10),
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Get selected charm products
 * @return {string[]} - List of selected bundle product item ID's
 */
function getCharmProducts() {
    var charmProducts = [];
    $('.slider-charms-popup .select-charm:checked').each(function () {
        const $this = $(this);
        charmProducts.push({
            pid: $this.data().charmId,
            quantity: parseInt($this.data().quantity, 10),
        });
    });

    return charmProducts.length ? JSON.stringify(charmProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            const $this = $(this);
            const $elOption = $this.find('.options-select');
            const urlValue = $elOption.val();
            const selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
            return {
                optionId: $this.data('option-id'),
                selectedValueId: selectedValueId,
            };
        })
        .toArray();

    return JSON.stringify(options);
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        base.methods.editBonusProducts.chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append('<div class="add-to-cart-messages"></div>');
        }

        $('.add-to-cart-messages').append('<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' + response.message + '</div>');

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    }
}

base.addToCart = function () {
    $(document)
        .off('click', 'button.add-to-cart, button.add-to-cart-global')
        .on('click', 'button.add-to-cart, button.add-to-cart-global', function (e, arg) {
            const actualTarget = arg?.triggeredBy || e.target;
            const stickyBar = arg?.stickyAtb || false;
            const $this = $(this);
            const formError = validateVarient.validate($this, actualTarget);
            if (formError) {
                if (stickyBar === true && $(actualTarget).hasClass('floating-add-to-cart-btn')) {
                    $('.error-msg').addClass('d-none');
                    $('.attribute label').removeClass('d-none');
                    $('.variations-overlay').removeClass('d-none');
                }
                $.spinner().stop();
                e.stopPropagation();
                e.stopImmediatePropagation();
            } else {
                if ($(actualTarget).hasClass('sticky-add-to-cart')) {
                    $('.variations-overlay').addClass('d-none');
                }

                var addToCartUrl;
                var pid;
                var pidsObj;
                var setPids;
                var qty;

                $('body').trigger('product:beforeAddToCart', this);

                if ($('.set-items').length && $this.hasClass('add-to-cart-global')) {
                    setPids = [];

                    $('.product-detail').each(function () {
                        const $thisInner = $(this);
                        if (!$thisInner.hasClass('product-set-detail')) {
                            setPids.push({
                                pid: $thisInner.find('.product-id').text(),
                                qty: $thisInner.find('.quantity-select').val(),
                                options: getOptions($thisInner),
                            });
                        }
                    });
                    pidsObj = JSON.stringify(setPids);
                }

                pid = base.getPidValue($this);

                var $productContainer = $this.closest('.product-detail');
                if (!$productContainer.length) {
                    $productContainer = $this.closest('.quick-view-dialog').find('.product-detail');
                }

                addToCartUrl = $('.add-to-cart-url').val();
                qty = $('.quickview-wrapper').hasClass('show') ? 1 : base.getQuantitySelected($this);

                var form = {
                    pid: pid,
                    pidsObj: pidsObj,
                    childProducts: getChildProducts(),
                    quantity: qty,
                    charmProducts: getCharmProducts(),
                };

                if (!$('.bundle-item').length) {
                    form.options = getOptions($productContainer);
                }

                $this.trigger('updateAddToCartFormData', form);
                if (addToCartUrl) {
                    $.ajax({
                        url: addToCartUrl,
                        method: 'POST',
                        data: form,
                        success: function (data) {
                            $('body').trigger('cart:update', data);
                            $('body').trigger('product:afterAddToCart', data);
                            handlePostCartAdd(data);
                            $.spinner().stop();
                            base.miniCartReportingUrl(data.reportingURL);
                        },
                        error: function () {
                            $.spinner().stop();
                        },
                    });
                }
            }
        });

    $('body').on('product:afterAddToCart', function (e, data) {
        if (data.error) {
            if (data.message) {
                $('.product-limit-modal .modal-body').text(data.message);
            } else if (data.messages) {
                $('.product-limit-modal .modal-body').text(data.messages[0]);
            }
            $('.product-limit-modal').modal('show');
        } else {
            $('body').trigger('minicart:update', data);
            $('.minicart-overlay-wrapper').addClass('mini-cart-close');
        }
    });
};

base.openSizeSelectionDrawer = function () {
    if ($('.pdp-right-wrapper').length && $('.add-to-wishlist-form.bottom-wishlist-section').is(':visible')) {
        let shouldOpen = false;
        $('.pdp-right-wrapper .attributes .attribute label').each(function () {
            if ($(this).text().toLowerCase().includes('size')) {
                $(document).trigger('openSlider', {
                    target: '#wishlist-size-selection-slider',
                });
                shouldOpen = true;
            }
        });
        return shouldOpen;
    }
    return false;
};

module.exports = base;
